import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { api, saveAuth } from "../lib/api";

export default function Login() {
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      const { data } = await api.post("/auth/login", form);
      saveAuth(data.token, data.user);
      toast.success("Welcome back!");
      nav(data.user.role === "admin" ? "/admin" : "/");
      window.location.reload();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  const googleMock = async () => {
    try {
      const { data } = await api.post("/auth/google", {
        email: "demo.user@gmail.com", name: "Demo User", picture: null,
      });
      saveAuth(data.token, data.user);
      toast.success("Signed in with Google");
      nav("/"); window.location.reload();
    } catch {
      toast.error("Google sign-in failed");
    }
  };

  return (
    <div className="fade-in min-h-[70vh] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md bg-white rounded-3xl border border-[#eae5d9] p-8 md:p-10">
        <h1 className="serif text-3xl font-semibold text-[#000080]">Welcome back</h1>
        <p className="text-sm text-[#737373] mt-1 mb-6">Login to manage your donations and profile.</p>
        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <Input required type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="login-email" />
          <Input required type="password" placeholder="Password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="login-password" />
          <Button type="submit" disabled={loading} className="w-full bg-[#FF9933] hover:bg-[#E68A2E] text-white h-12 rounded-full btn-glow" data-testid="login-submit">
            {loading ? "Signing in..." : "Sign In"}
          </Button>
        </form>
        <div className="my-5 flex items-center gap-3 text-xs text-[#737373]">
          <div className="h-px flex-1 bg-[#eae5d9]" /> OR <div className="h-px flex-1 bg-[#eae5d9]" />
        </div>
        <Button onClick={googleMock} variant="outline" className="w-full h-12 rounded-full border-[#eae5d9]" data-testid="login-google">
          <svg className="w-4 h-4 mr-2" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.1c-.22-.66-.35-1.36-.35-2.1s.13-1.44.35-2.1V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.83z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.46 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"/></svg>
          Continue with Google
        </Button>
        <p className="text-sm text-center text-[#737373] mt-6">
          No account? <Link to="/register" className="text-[#FF9933] font-semibold" data-testid="login-to-register">Register</Link>
        </p>
      </div>
    </div>
  );
}
